var _g, _path, _g2, _path2, _g3, _path3, _g4, _path4, _g5, _path5, _g6, _path6, _g7, _path7, _g8, _path8, _g9, _path9, _g10, _path10, _g11, _path11, _g12, _path12, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTimanityMiniGamesLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 550,
    height: 550,
    viewBox: "0 0 550 550",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_204_9)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M205 425H45C33.9543 425 25 433.954 25 445V505C25 516.046 33.9543 525 45 525H205C216.046 525 225 516.046 225 505V445C225 433.954 216.046 425 205 425Z",
    fill: "#1C2F4E",
    fillOpacity: 0.01
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45 426.5H205C215.217 426.5 223.5 434.783 223.5 445V505C223.5 515.217 215.217 523.5 205 523.5H45C34.7827 523.5 26.5 515.217 26.5 505V445C26.5 434.783 34.7827 426.5 45 426.5Z",
    stroke: "white",
    strokeWidth: 3
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_204_9)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M325 345V505C325 516.045 333.955 525 345.001 525H405C416.046 525 425 516.045 425 505V325H345C333.955 325 325 333.954 325 345Z",
    fill: "#1C2F4E",
    fillOpacity: 0.01
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M326.5 505V345C326.5 334.783 334.783 326.5 345 326.5H423.5V505C423.5 515.217 415.218 523.5 405 523.5H345.001C334.783 523.5 326.5 515.217 326.5 505Z",
    stroke: "white",
    strokeWidth: 3
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_204_9)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M505 325H345C333.955 325 325 333.954 325 345V425H505C516.046 425 525 416.046 525 405V345C525 333.954 516.046 325 505 325Z",
    fill: "#1C2F4E",
    fillOpacity: 0.01
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M345 326.5H505C515.217 326.5 523.5 334.783 523.5 345V405C523.5 415.217 515.217 423.5 505 423.5H326.5V345C326.5 334.783 334.783 326.5 345 326.5Z",
    stroke: "white",
    strokeWidth: 3
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_i_204_9)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M425 45.0001V205C425 216.046 433.954 225 445 225H504.999C516.045 225 524.999 216.046 524.999 205V45.0001C524.999 33.9544 516.045 25.0001 504.999 25.0001H445C433.954 25.0001 425 33.9544 425 45.0001Z",
    fill: "#1C2F4E",
    fillOpacity: 0.01
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M426.5 205V45.0001C426.5 34.7828 434.782 26.5001 445 26.5001H504.999C515.217 26.5001 523.499 34.7828 523.499 45.0001V205C523.499 215.217 515.217 223.5 504.999 223.5H445C434.782 223.5 426.5 215.217 426.5 205Z",
    stroke: "white",
    strokeWidth: 3
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_i_204_9)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M125 25.0001L125 305C125 316.046 133.954 325 145 325H205C216.046 325 225 316.046 225 305V25.0001H125Z",
    fill: "#1C2F4E",
    fillOpacity: 0.01
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M126.5 305L126.5 26.5001H223.5V305C223.5 315.217 215.217 323.5 205 323.5H145C134.783 323.5 126.5 315.217 126.5 305Z",
    stroke: "white",
    strokeWidth: 3
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_i_204_9)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M305 25.0005H45C33.9543 25.0005 25 33.9548 25 45.0005V105C25 116.046 33.9543 125 45 125H305C316.046 125 325 116.046 325 105V45.0005C325 33.9549 316.046 25.0005 305 25.0005Z",
    fill: "#1C2F4E",
    fillOpacity: 0.01
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M45 26.5005H305C315.217 26.5005 323.5 34.7833 323.5 45.0005V105C323.5 115.218 315.217 123.5 305 123.5H45C34.7827 123.5 26.5 115.218 26.5 105V45.0005C26.5 34.7833 34.7827 26.5005 45 26.5005Z",
    stroke: "white",
    strokeWidth: 3
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_i_204_9)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M205 425H45C33.9543 425 25 433.954 25 445V505C25 516.046 33.9543 525 45 525H205C216.046 525 225 516.046 225 505V445C225 433.954 216.046 425 205 425Z",
    fill: "#1C2F4E",
    fillOpacity: 0.01
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M45 426.5H205C215.217 426.5 223.5 434.783 223.5 445V505C223.5 515.217 215.217 523.5 205 523.5H45C34.7827 523.5 26.5 515.217 26.5 505V445C26.5 434.783 34.7827 426.5 45 426.5Z",
    stroke: "white",
    strokeWidth: 3
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_i_204_9)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M325 345V505C325 516.045 333.955 525 345.001 525H405C416.046 525 425 516.045 425 505V325H345C333.955 325 325 333.954 325 345Z",
    fill: "#1C2F4E",
    fillOpacity: 0.01
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M326.5 505V345C326.5 334.783 334.783 326.5 345 326.5H423.5V505C423.5 515.217 415.218 523.5 405 523.5H345.001C334.783 523.5 326.5 515.217 326.5 505Z",
    stroke: "white",
    strokeWidth: 3
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_i_204_9)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M505 325H345C333.955 325 325 333.954 325 345V425H505C516.046 425 525 416.046 525 405V345C525 333.954 516.046 325 505 325Z",
    fill: "#1C2F4E",
    fillOpacity: 0.01
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M345 326.5H505C515.217 326.5 523.5 334.783 523.5 345V405C523.5 415.217 515.217 423.5 505 423.5H326.5V345C326.5 334.783 334.783 326.5 345 326.5Z",
    stroke: "white",
    strokeWidth: 3
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_i_204_9)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M425 45.0001V205C425 216.046 433.954 225 445 225H504.999C516.045 225 524.999 216.046 524.999 205V45.0001C524.999 33.9544 516.045 25.0001 504.999 25.0001H445C433.954 25.0001 425 33.9544 425 45.0001Z",
    fill: "#1C2F4E",
    fillOpacity: 0.01
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M426.5 205V45.0001C426.5 34.7828 434.782 26.5001 445 26.5001H504.999C515.217 26.5001 523.499 34.7828 523.499 45.0001V205C523.499 215.217 515.217 223.5 504.999 223.5H445C434.782 223.5 426.5 215.217 426.5 205Z",
    stroke: "white",
    strokeWidth: 3
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_i_204_9)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M125 25.0001L125 305C125 316.046 133.954 325 145 325H205C216.046 325 225 316.046 225 305V25.0001H125Z",
    fill: "#1C2F4E",
    fillOpacity: 0.01
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M126.5 305L126.5 26.5001H223.5V305C223.5 315.217 215.217 323.5 205 323.5H145C134.783 323.5 126.5 315.217 126.5 305Z",
    stroke: "white",
    strokeWidth: 3
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter11_i_204_9)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M305 25.0005H45C33.9543 25.0005 25 33.9548 25 45.0005V105C25 116.046 33.9543 125 45 125H305C316.046 125 325 116.046 325 105V45.0005C325 33.9549 316.046 25.0005 305 25.0005Z",
    fill: "#1C2F4E",
    fillOpacity: 0.01
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M45 26.5005H305C315.217 26.5005 323.5 34.7833 323.5 45.0005V105C323.5 115.218 315.217 123.5 305 123.5H45C34.7827 123.5 26.5 115.218 26.5 105V45.0005C26.5 34.7833 34.7827 26.5005 45 26.5005Z",
    stroke: "white",
    strokeWidth: 3
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_204_9",
    x: 25,
    y: 425,
    width: 200,
    height: 100,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 30
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.74902 0 0 0 0 0.647059 0 0 0 0 0.980392 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_204_9"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_204_9",
    x: 325,
    y: 325,
    width: 99.9998,
    height: 200,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 30
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.74902 0 0 0 0 0.647059 0 0 0 0 0.980392 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_204_9"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_204_9",
    x: 325,
    y: 325,
    width: 200,
    height: 99.9999,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 30
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.74902 0 0 0 0 0.647059 0 0 0 0 0.980392 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_204_9"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_i_204_9",
    x: 425,
    y: 25.0001,
    width: 99.9998,
    height: 200,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 30
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.74902 0 0 0 0 0.647059 0 0 0 0 0.980392 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_204_9"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_i_204_9",
    x: 125,
    y: 25.0001,
    width: 100,
    height: 300,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 30
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.74902 0 0 0 0 0.647059 0 0 0 0 0.980392 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_204_9"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_i_204_9",
    x: 25,
    y: 25.0005,
    width: 300,
    height: 99.9999,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 30
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.74902 0 0 0 0 0.647059 0 0 0 0 0.980392 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_204_9"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_i_204_9",
    x: 25,
    y: 425,
    width: 200,
    height: 100,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 30
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.74902 0 0 0 0 0.647059 0 0 0 0 0.980392 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_204_9"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_i_204_9",
    x: 325,
    y: 325,
    width: 99.9998,
    height: 200,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 30
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.74902 0 0 0 0 0.647059 0 0 0 0 0.980392 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_204_9"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_i_204_9",
    x: 325,
    y: 325,
    width: 200,
    height: 99.9999,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 30
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.74902 0 0 0 0 0.647059 0 0 0 0 0.980392 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_204_9"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_i_204_9",
    x: 425,
    y: 25.0001,
    width: 99.9998,
    height: 200,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 30
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.74902 0 0 0 0 0.647059 0 0 0 0 0.980392 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_204_9"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_i_204_9",
    x: 125,
    y: 25.0001,
    width: 100,
    height: 300,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 30
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.74902 0 0 0 0 0.647059 0 0 0 0 0.980392 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_204_9"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_i_204_9",
    x: 25,
    y: 25.0005,
    width: 300,
    height: 99.9999,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 30
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.74902 0 0 0 0 0.647059 0 0 0 0 0.980392 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_204_9"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimanityMiniGamesLogo);
export default __webpack_public_path__ + "static/media/Timanity MiniGames Logo.cb8d8696cc776a65106856f1cfbf872e.svg";
export { ForwardRef as ReactComponent };